import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { LanguageService, languages } from '@catch/services';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgSelectModule } from '@ng-select/ng-select';
import { TargetBlankDirective } from '../../../directives/target-blank.directive';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ColorService } from '../../../services/color.service';
import { EmbedService } from '../../../services/embed.service';
import { FontawesomeService } from '../../../services/fontawesome.service';
import { SEOService } from '../../../services/seo.service';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, FaIconComponent, NgSelectModule, TranslocoPipe, TargetBlankDirective],
})
export class HeaderComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  public readonly colorService = inject(ColorService);
  public readonly embedService = inject(EmbedService);
  public readonly fontawesomeService = inject(FontawesomeService);
  public readonly languageService = inject(LanguageService);
  public readonly seoService = inject(SEOService);

  languages = languages;

  constructor() {
    this.colorService.changeEvent$.pipe(untilDestroyed(this)).subscribe(() => {
      this.cdr.markForCheck();
    });
  }
}
